// extracted by mini-css-extract-plugin
export default {"wrapper":"Popper_wrapper__M-TRP","action-wrapper":"Popper_action-wrapper__W7ZQe"};